export default {
    methods: {
        setSelectedListItemId(id) {
            this.$store.dispatch('setSelectedListItemId', id)
        },
        clearSelectedListItemId() {
            this.$store.dispatch('clearSelectedListItemId')
        },
    }
}